import React, { VFC } from 'react';
import T from 'i18n-react';
import camelCase from 'lodash/camelCase';
import { PLANS } from '../../../routing';
import { Plan } from '..';
import PLanListSlick from '../../../Plans/ListSlick';
import CardsLineWrapper from '../molecules/CardsLineWrapper';
import { UsersitePlansGetManyPlansTypePayload } from '~/models/schema';
import {
  FARMER_PLANS_MORE_LINK,
  HOTEL_PLANS_MORE_LINK,
  NEW_PLANS_MORE_LINK,
  OTHER_CATEGORY_PLANS_MORE_LINK,
} from '~/src/front/constants/gtm';

const NEW_PLANS_KEY = 'recently_published_plans';
const HOTEL_PLANS_KEY = 'hotel_plans';
const FARMER_PLANS_KEY = 'farmer_plans';
const OTHER_CATEGORY_PLANS_KEY = 'other_category_plans';

const dataGtmConverter = {
  [NEW_PLANS_KEY]: NEW_PLANS_MORE_LINK,
  [HOTEL_PLANS_KEY]: HOTEL_PLANS_MORE_LINK,
  [FARMER_PLANS_KEY]: FARMER_PLANS_MORE_LINK,
  [OTHER_CATEGORY_PLANS_KEY]: OTHER_CATEGORY_PLANS_MORE_LINK,
};

interface Props {
  isAuthenticated: boolean;
  plans: Plan[];
}
const PlanLines: VFC<Props> = ({ isAuthenticated, plans }: Props) => {
  // 募集の一覧を、半分に分割するためのメソッド
  const halvePlans = (
    plans: UsersitePlansGetManyPlansTypePayload[],
    halfIndex: number,
  ): {
    firstPlans: UsersitePlansGetManyPlansTypePayload[];
    lastPlans: UsersitePlansGetManyPlansTypePayload[];
  } => {
    return plans.reduce(
      (prevValue, currentValue, index) => {
        index <= halfIndex
          ? prevValue.firstPlans.push(currentValue)
          : prevValue.lastPlans.push(currentValue);
        return prevValue;
      },
      { firstPlans: [], lastPlans: [] } as {
        firstPlans: UsersitePlansGetManyPlansTypePayload[];
        lastPlans: UsersitePlansGetManyPlansTypePayload[];
      },
    );
  };

  return (
    <>
      {plans.map(({ key, plans, queryParams }: Plan) => {
        // 新着の募集の場合
        const { firstPlans, lastPlans } = halvePlans(plans, 8);
        if (key === NEW_PLANS_KEY) {
          return (
            <CardsLineWrapper
              key={key}
              title={T.translate(`homes.plans.${camelCase(key)}.title`)}
              linkProps={{
                href: `${PLANS}?${queryParams || ''}`,
                'data-gtm': dataGtmConverter[key],
              }}
            >
              <PLanListSlick
                plans={firstPlans}
                isAuthenticated={isAuthenticated}
                // IntersectionObserverAPIの挙動を正しく利用できるまで、
                // 募集一覧は画像の遅延読み込みを行わない
                defaultIsVisible
                showRequestBadge
              />
              <PLanListSlick
                plans={lastPlans}
                isAuthenticated={isAuthenticated}
                // IntersectionObserverAPIの挙動を正しく利用できるまで、
                // 募集一覧は画像の遅延読み込みを行わない
                defaultIsVisible
                showRequestBadge
              />
            </CardsLineWrapper>
          );
        }

        // 新着ではない募集の場合
        return (
          <CardsLineWrapper
            key={key}
            title={T.translate(`homes.plans.${camelCase(key)}.title`)}
            linkProps={{
              href: `${PLANS}?${queryParams || ''}`,
              'data-gtm': dataGtmConverter[key],
            }}
          >
            <PLanListSlick
              plans={plans}
              isAuthenticated={isAuthenticated}
              // IntersectionObserverAPIの挙動を正しく利用できるまで、
              // 募集一覧は画像の遅延読み込みを行わない
              defaultIsVisible
            />
          </CardsLineWrapper>
        );
      })}
    </>
  );
};

export default PlanLines;
